import { render, staticRenderFns } from "./Media.vue?vue&type=template&id=9d6cae1c&scoped=true&"
import script from "./Media.vue?vue&type=script&lang=ts&"
export * from "./Media.vue?vue&type=script&lang=ts&"
import style0 from "./Media.vue?vue&type=style&index=0&id=9d6cae1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6cae1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d6cae1c')) {
      api.createRecord('9d6cae1c', component.options)
    } else {
      api.reload('9d6cae1c', component.options)
    }
    module.hot.accept("./Media.vue?vue&type=template&id=9d6cae1c&scoped=true&", function () {
      api.rerender('9d6cae1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/Media.vue"
export default component.exports